/*
  Sher Organics - homepage motion (PRD Section 8). Vanilla JS, no libraries.
  Ported from docs/sher-organics-concept-v8.html: scroll reveal, hero
  slideshow with dots and autoplay, subtle parallax, and a shared video modal
  for the hero Watch trigger and the video band. All motion respects
  prefers-reduced-motion.
*/
(function () {
  'use strict';
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---- Scroll reveal ---- */
  function initReveal() {
    var reveals = document.querySelectorAll('[data-reveal]');
    if (!reveals.length) return;
    if (reduce || !('IntersectionObserver' in window)) {
      reveals.forEach(function (el) { el.classList.add('in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('in');
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    reveals.forEach(function (el) { io.observe(el); });
  }

  /* ---- Hero slideshow: dots + autoplay crossfade ---- */
  function initHero(hero) {
    var slides = hero.querySelectorAll('.hero-slides .slide');
    var dotsWrap = hero.querySelector('.hero-dots');
    if (!slides.length || !dotsWrap) return;
    var cur = 0;
    slides.forEach(function (s, i) {
      var b = document.createElement('button');
      if (i === 0) b.className = 'on';
      b.setAttribute('aria-label', 'Slide ' + (i + 1));
      b.addEventListener('click', function () { go(i); });
      dotsWrap.appendChild(b);
    });
    var dots = dotsWrap.querySelectorAll('button');
    function go(i) {
      slides[cur].classList.remove('active');
      dots[cur].classList.remove('on');
      cur = i;
      slides[cur].classList.add('active');
      dots[cur].classList.add('on');
    }
    var interval = parseFloat(hero.getAttribute('data-autoplay')) || 5500;
    if (!reduce && slides.length > 1) {
      setInterval(function () { go((cur + 1) % slides.length); }, interval);
    }
  }

  /* ---- Shared video modal ---- */
  var modal, modalMedia, lastActive;
  function buildModal() {
    if (modal) return;
    modal = document.createElement('div');
    modal.className = 'vbox';
    modal.innerHTML =
      '<div class="vbox__inner">' +
      '<button class="vbox__close" aria-label="Close video">' +
      '<svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M6 6l12 12M18 6L6 18"/></svg>' +
      '</button><div class="vbox__media"></div></div>';
    document.body.appendChild(modal);
    modalMedia = modal.querySelector('.vbox__media');
    modal.addEventListener('click', function (e) {
      if (e.target === modal) closeModal();
    });
    modal.querySelector('.vbox__close').addEventListener('click', closeModal);
    // Keyboard: trap focus inside the dialog and close on Escape. Capture phase
    // so Escape fires even when focus is on the <video> element, whose native
    // controls would otherwise swallow the key.
    modal.addEventListener(
      'keydown',
      function (e) {
        if (e.key === 'Escape') {
          e.preventDefault();
          closeModal();
          return;
        }
        if (e.key !== 'Tab') return;
        var f = Array.prototype.filter.call(
          modal.querySelectorAll('button, a[href], video, iframe, [tabindex]:not([tabindex="-1"])'),
          function (el) { return el.offsetParent !== null || el === document.activeElement; }
        );
        if (!f.length) return;
        var first = f[0], last = f[f.length - 1];
        if (e.shiftKey && document.activeElement === first) {
          e.preventDefault();
          last.focus();
        } else if (!e.shiftKey && document.activeElement === last) {
          e.preventDefault();
          first.focus();
        }
      },
      true
    );
  }
  function ytId(url) {
    var m = url.match(/(?:youtu\.be\/|youtube\.com\/(?:watch\?v=|embed\/|v\/))([\w-]{11})/);
    return m ? m[1] : null;
  }
  function vimeoId(url) {
    var m = url.match(/vimeo\.com\/(?:video\/)?(\d+)/);
    return m ? m[1] : null;
  }
  function openModal(url) {
    if (!url) return;
    buildModal();
    lastActive = document.activeElement;
    var yt = ytId(url), vm = vimeoId(url);
    if (yt) {
      modalMedia.innerHTML = '<iframe src="https://www.youtube.com/embed/' + yt + '?autoplay=1&rel=0" allow="autoplay; fullscreen" allowfullscreen></iframe>';
    } else if (vm) {
      modalMedia.innerHTML = '<iframe src="https://player.vimeo.com/video/' + vm + '?autoplay=1" allow="autoplay; fullscreen" allowfullscreen></iframe>';
    } else {
      modalMedia.innerHTML = '<video controls playsinline autoplay src="' + url + '"></video>';
    }
    modal.classList.add('open');
    document.body.classList.add('locked');
    modal.querySelector('.vbox__close').focus();
  }
  function closeModal() {
    if (!modal) return;
    modal.classList.remove('open');
    document.body.classList.remove('locked');
    modalMedia.innerHTML = '';
    if (lastActive && lastActive.focus) lastActive.focus();
  }
  function initVideoTriggers() {
    document.querySelectorAll('[data-video-trigger]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        openModal(btn.getAttribute('data-video-url'));
      });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeModal();
    });
  }

  /* ---- Parallax: subtle translate + slight scale ---- */
  function initParallax() {
    var els = document.querySelectorAll('[data-parallax]');
    if (!els.length || reduce) return;
    function run() {
      var vh = window.innerHeight;
      els.forEach(function (el) {
        var box = el.parentElement.getBoundingClientRect();
        var prog = (box.top + box.height / 2 - vh / 2) / vh;
        prog = Math.max(-1, Math.min(1, prog));
        el.style.transform = 'translateY(' + (prog * -18).toFixed(1) + 'px) scale(1.12)';
      });
    }
    run();
    window.addEventListener('scroll', function () { requestAnimationFrame(run); }, { passive: true });
    window.addEventListener('resize', run);
  }

  function init() {
    initReveal();
    document.querySelectorAll('.hero').forEach(initHero);
    initVideoTriggers();
    initParallax();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
